"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_business__phone__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.5 191.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#4a4d4e;}.cls-3{fill:none;}.cls-4,.cls-5{fill:#333;}.cls-4,.cls-7{opacity:0.2;}.cls-6{opacity:0.5;fill:url(#Unbenannter_Verlauf_11);}.cls-7{fill:url(#Unbenannter_Verlauf_12);}.cls-8{fill:#e60000;}.cls-9{opacity:0.06;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_11",
    x1: 89.84,
    y1: 44.84,
    x2: 141.66,
    y2: 96.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12",
    x1: 24.57,
    y1: 61.95,
    x2: 146.62,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "business-phone-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business_phone_ic_hi_2",
    "data-name": "Business_phone_ic_hi 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.25,27.75h104.5a16,16,0,0,1,16,16v104a16,16,0,0,1-16,16H55.25a0,0,0,0,1,0,0v-136A0,0,0,0,1,55.25,27.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.76,
    y: 99.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.76,
    y: 111.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.76,
    y: 123.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-3",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 49.75,
    width: 72,
    height: 42,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161,164H58.74L58.51,28,176,145.5l0,3.53C176,157.25,167.75,164,161,164Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 145.75,
    cy: 144.17,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.75,
    y: 23.75,
    width: 48,
    height: 144,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M160,162H60.48A15.91,15.91,0,0,0,64,152v-2a15.93,15.93,0,0,1-5.44,12,16.37,16.37,0,0,1-2.82,2A15.92,15.92,0,0,1,48,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H48a15.94,15.94,0,0,0,10.56-4H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,162Z",
    transform: "translate(-0.25 -0.25)"
  }))));
}

var _default = ic_business__phone__dark;
exports.default = _default;